(() => {
  const root = document;
  const surfaces = () => [...root.querySelectorAll('[data-luvera-surface]')];
  const scrim = root.querySelector('.luvera-scrim');

  const closeSurfaces = () => {
    surfaces().forEach((surface) => {
      if (surface.tagName === 'DIALOG') {
        if (surface.open) surface.close();
      } else {
        surface.hidden = true;
      }
    });
    if (scrim) scrim.hidden = true;
    document.documentElement.classList.remove('luvera-panel-open');
    delete document.documentElement.dataset.luveraActiveSurface;
  };

  // odakla=false: fareyle acilan mega menude ilk baglantiya odak kutusu cizilmesin.
  // Tiklama/klavye yolunda odak KORUNUR (erisilebilirlik).
  const openSurface = (name, odakla = true) => {
    const surface = root.querySelector(`[data-luvera-surface="${name}"]`);
    if (!surface) return;
    const wasOpen = surface.tagName === 'DIALOG' ? surface.open : !surface.hidden;
    closeSurfaces();
    if (wasOpen) return;
    if (surface.tagName === 'DIALOG') surface.showModal();
    else surface.hidden = false;
    if (scrim && !['size-guide'].includes(name)) scrim.hidden = false;
    document.documentElement.classList.add('luvera-panel-open');
    document.documentElement.dataset.luveraActiveSurface = name;
    if (odakla) (name === 'search' ? surface.querySelector('input') : surface.querySelector('button, input, a'))?.focus({ preventScroll: true });
  };

  root.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-luvera-open]');
    if (opener) {
      event.preventDefault();
      openSurface(opener.dataset.luveraOpen);
      return;
    }
    if (event.target.closest('[data-luvera-close]')) closeSurfaces();
  });
  root.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeSurfaces(); });

  /* MEGA MENU: masaustu/tablette uzerine gelince acilir, alandan cikinca kapanir.
     Dokunmatik cihazda hover olmadigi icin tiklama yolu aynen calismaya devam eder. */
  const hoverTetik = root.querySelector('[data-luvera-hover]');
  if (hoverTetik && window.matchMedia('(hover:hover) and (min-width:601px)').matches) {
    const hedefAd = hoverTetik.dataset.luveraHover;
    const panel = root.querySelector(`[data-luvera-surface="${hedefAd}"]`);
    let kapatmaZamani = null;
    const iptal = () => { if (kapatmaZamani) { clearTimeout(kapatmaZamani); kapatmaZamani = null; } };
    const gecikmeliKapat = () => { iptal(); kapatmaZamani = setTimeout(() => { if (panel && !panel.hidden) closeSurfaces(); }, 160); };
    hoverTetik.addEventListener('mouseenter', () => { iptal(); if (panel?.hidden) openSurface(hedefAd, false); });
    hoverTetik.addEventListener('mouseleave', gecikmeliKapat);
    panel?.addEventListener('mouseenter', iptal);
    panel?.addEventListener('mouseleave', gecikmeliKapat);
  }
  // aria-expanded gercek duruma bagli kalsin
  const ariaEsitle = () => root.querySelectorAll('[data-luvera-open]').forEach((tetik) => {
    const p = root.querySelector(`[data-luvera-surface="${tetik.dataset.luveraOpen}"]`);
    if (p && tetik.hasAttribute('aria-expanded')) tetik.setAttribute('aria-expanded', String(!p.hidden));
  });
  new MutationObserver(ariaEsitle).observe(root.documentElement, { attributes: true, attributeFilter: ['data-luvera-active-surface'] });
  ariaEsitle();

  // DUZELTME (olculdu, evidence/source-probe-sticky-header-v01): kaynakta header
  // KAYDIRINCA SABITLENIYOR. header-component.header__wrapper -> position:fixed, top:0,
  // z-index:5600, .js__header__stuck sinifi. Esik = duyuru cubugunun yuksekligi
  // (mobil 68.28, tablet 53.89, masaustu 60.3). Header yuksekligi 55.13/57.13/59.13.
  // Onceki "yapiskan degil" tespiti yanlisti: o prob .page-header ariyordu, hic eslesmedi.
  const headerSections = root.querySelector("[data-luvera-header]");
  const offerBar = headerSections?.querySelector(".luvera-offer");
  const syncStuckHeader = () => {
    if (!headerSections || !offerBar) return;
    const threshold = offerBar.getBoundingClientRect().height;
    headerSections.classList.toggle("is-stuck", window.scrollY >= threshold);
  };
  window.addEventListener("scroll", syncStuckHeader, { passive: true });
  window.addEventListener("resize", syncStuckHeader);
  syncStuckHeader();

  const stickyBuy = root.querySelector('[data-luvera-product-sticky]');
  const productBuy = root.querySelector('.luvera-product-buy');
  const productMain = root.querySelector('.luvera-product-main');
  const primaryAddButton = root.querySelector('.luvera-add');
  const syncStickyBuy = () => {
    const crossedThreshold = window.innerWidth <= 600
      ? primaryAddButton?.getBoundingClientRect().bottom < 0
      : window.scrollY > 150;
    const visible = Boolean(stickyBuy && primaryAddButton && crossedThreshold);
    stickyBuy?.classList.toggle('is-visible', visible);
    stickyBuy?.setAttribute('aria-hidden', String(!visible));
    productBuy?.classList.toggle('is-stuck', visible);
    // Satin alma kolonu yapiskanligi CSS'te: position:sticky + sabit top
    // (masaustu 59px, tablet 57px = olculen header yuksekligi; mobilde position:static).
    //
    // CANLI kaynak `top`u kaydirmayla guncelliyor; olculen kural
    // (evidence/source-probe-buy-sticky-v01/buy-sticky-probe.json, 2 viewport x 6 kaydirma):
    //   top = max(viewportH - kolonYuksekligi - 30, headerYuksekligi - scrollY)
    // ANCAK GOLDEN kanitta kaydirilmis karelerde kaynak kolonu tepeye yakin duruyor; golden
    // cekimi kaynagin bu guncellemesini tetiklememis ve efektif olarak SABIT top durumunu
    // kaydetmis. Skorun otoritesi golden oldugu icin sabit top kullaniliyor. Bu fark
    // raporlanmistir (canli kaynakla davranis farki, golden ile uyum).
    //
    // Onceki parcali-dogrusal "--luvera-desktop-buy-shift" yamasi hicbir olcume dayanmiyordu
    // ve kaydirmada kolonu ~28px kaydiriyordu; kaldirildi.
    productBuy?.classList.remove('is-past-product');
    productBuy?.style.removeProperty('--luvera-buy-top');
  };
  window.addEventListener('scroll', syncStickyBuy, { passive: true });
  syncStickyBuy();
  stickyBuy?.querySelector('[data-luvera-sticky-add]')?.addEventListener('click', () => productForm?.requestSubmit());

  // Geri sayim. Kaynakta bicim "SS : DD : SN" (uc alan, aralarinda solgun iki nokta).
  // Sure tema ayarindan gelir; kaynak script'i degil, olculen bicimi yeniden kurduk.
  /* GERI SAYIM — GERCEK BITIS TARIHI
     Onceden `Date.now() + N saat` idi: sayac HER SAYFA YUKLEMESINDE sifirlaniyordu,
     yani sahte aciliyet gosteriyordu (olculdu: 1. yukleme 00:59:53, 2. yukleme 00:59:55).
     Artik `data-luvera-deadline` ile sabit bir bitis anina sayiyor; tarih gecince
     sayac ve varsa bagli kampanya satiri gizleniyor. Tarih yoksa eski saat davranisi kalir. */
  root.querySelectorAll('[data-luvera-countdown]').forEach((countdown) => {
    const ham = countdown.dataset.luveraDeadline;
    const hedef = ham ? Date.parse(ham) : NaN;
    const sabitBitis = Number.isFinite(hedef);
    const hours = Number(countdown.dataset.luveraCountdown) || 3;
    const deadline = sabitBitis ? hedef : Date.now() + hours * 60 * 60 * 1000;
    const slotD = countdown.querySelector('[data-luvera-cd-d]');
    const kutuD = slotD ? slotD.closest('[data-luvera-cd-day-box]') || slotD.parentElement : null;
    const ayracD = countdown.querySelector('[data-luvera-cd-day-sep]');
    const slotH = countdown.querySelector('[data-luvera-cd-h]');
    const slotM = countdown.querySelector('[data-luvera-cd-m]');
    const slotS = countdown.querySelector('[data-luvera-cd-s]');
    const pad = (n) => String(n).padStart(2, '0');
    let zamanlayici = null;
    const renderCountdown = () => {
      const left = Math.max(0, deadline - Date.now());
      if (sabitBitis && left === 0) {
        // Kampanya bitti: sayaci ve bagli satiri gizle, uydurma sure gosterme.
        const kapsayici = countdown.closest('[data-luvera-promo-line]') || countdown;
        kapsayici.hidden = true;
        if (zamanlayici) window.clearInterval(zamanlayici);
        return;
      }
      const gun = Math.floor(left / 86400000);
      const h = pad(Math.floor((left % 86400000) / 3600000));
      const m = pad(Math.floor((left % 3600000) / 60000));
      const s = pad(Math.floor((left % 60000) / 1000));
      if (slotD) {
        slotD.textContent = pad(gun);
        if (kutuD) kutuD.hidden = gun === 0;
        if (ayracD) ayracD.hidden = gun === 0;
      }
      if (slotH) { slotH.textContent = h; slotM.textContent = m; slotS.textContent = s; }
      else countdown.textContent = (gun ? `${pad(gun)} : ` : '') + `${h} : ${m} : ${s}`;
    };
    renderCountdown();
    zamanlayici = window.setInterval(renderCountdown, 1000);
  });

  root.querySelectorAll('[data-luvera-rail]').forEach((rail) => {
    const viewport = rail.querySelector('.luvera-rail__viewport, .luvera-collections-showcase__rail');
    if (!viewport) return;
    rail.querySelector('[data-luvera-rail-next]')?.addEventListener('click', () => viewport.scrollBy({ left: viewport.clientWidth * .78, behavior: 'smooth' }));
    rail.querySelector('[data-luvera-rail-prev]')?.addEventListener('click', () => viewport.scrollBy({ left: -viewport.clientWidth * .78, behavior: 'smooth' }));
  });

  root.querySelectorAll('[data-luvera-gallery]').forEach((button) => {
    button.addEventListener('click', () => {
      if (window.innerWidth > 600) return;
      const gallery = button.closest('.luvera-product-gallery');
      const items = [...gallery.querySelectorAll('[data-luvera-gallery]')];
      const dots = [...gallery.querySelectorAll('.luvera-product-gallery__dots i')];
      const thumbnails = [...gallery.querySelectorAll('[data-luvera-thumbnail]')];
      const next = (items.indexOf(button) + 1) % items.length;
      items.forEach((item, index) => item.classList.toggle('is-active', index === next));
      dots.forEach((dot, index) => dot.classList.toggle('is-active', index === next));
      thumbnails.forEach((thumbnail, index) => thumbnail.classList.toggle('is-active', index === next));
    });
  });

  root.querySelectorAll('[data-luvera-thumbnail]').forEach((thumbnail) => {
    thumbnail.addEventListener('click', () => {
      if (window.innerWidth > 600) return;
      const gallery = thumbnail.closest('.luvera-product-gallery');
      const target = Number(thumbnail.dataset.luveraThumbnail) - 1;
      gallery.querySelectorAll('[data-luvera-gallery]').forEach((item, index) => item.classList.toggle('is-active', index === target));
      gallery.querySelectorAll('.luvera-product-gallery__dots i').forEach((dot, index) => dot.classList.toggle('is-active', index === target));
      gallery.querySelectorAll('[data-luvera-thumbnail]').forEach((item, index) => item.classList.toggle('is-active', index === target));
    });
  });

  const productRoot = root.querySelector('[data-luvera-product]');
  const productForm = root.querySelector('[data-luvera-product-form]');
  let productData = null;
  const productJson = root.querySelector('[data-luvera-product-json]');
  if (productJson) {
    try { productData = JSON.parse(productJson.textContent); } catch (_) { productData = null; }
  }
  productRoot?.querySelectorAll('[data-luvera-option]').forEach((button) => {
    button.addEventListener('click', () => {
      const group = button.closest('.luvera-size-options');
      group.querySelectorAll('button').forEach((item) => item.classList.toggle('is-selected', item === button));
      button.closest('fieldset')?.querySelector('[data-luvera-option-value]')?.replaceChildren(button.dataset.luveraOption);
      const lineProperty = button.closest('fieldset')?.querySelector('[data-luvera-line-property]');
      if (lineProperty) {
        lineProperty.value = button.dataset.luveraOption;
        return;
      }
      const selected = [...productRoot.querySelectorAll('[data-luvera-option].is-selected')].map((item) => item.dataset.luveraOption);
      const variant = productData?.variants?.find((item) => item.options.every((option, index) => option === selected[index]));
      const input = productForm?.querySelector('[data-luvera-variant-id]');
      if (input && variant) input.value = variant.id;
      stokDurumunuYaz(variant);
    });
  });

  /* STOK DURUMU — beden degisince buton ve stok satiri gercek veriyi gostersin.
     Onceden buton yalniz urun bos iken kapaniyordu: tukenmis bedeni secen musteri
     yine "SEPETE EKLE" goruyor ve ekleyebiliyordu. */
  function stokDurumunuYaz(variant) {
    const ekle = productForm?.querySelector('.luvera-add');
    if (!ekle) return;
    const varMi = !!variant && variant.available !== false;
    ekle.disabled = !varMi;
    const fiyat = ekle.dataset.price || '';
    if (varMi) {
      ekle.textContent = (ekle.dataset.atcLabel || 'SEPETE EKLE') + ' ';
      const s = document.createElement('span');
      s.textContent = '• ' + fiyat;
      ekle.appendChild(s);
    } else {
      ekle.textContent = ekle.dataset.soldLabel || 'TÜKENDİ';
    }
    const kutu = productRoot?.querySelector('[data-luvera-stock]');
    if (!kutu) return;
    const adet = variant && typeof variant.inventory_quantity === 'number' ? variant.inventory_quantity : null;
    let yazi = 'Stokta var', sinif = '';
    if (!varMi) { yazi = 'Bu seçenek tükendi'; sinif = 'is-out'; }
    else if (adet !== null && adet > 0 && adet <= 5) { yazi = 'Son ' + adet + ' adet'; }
    kutu.replaceChildren();
    const li = document.createElement('li');
    if (sinif) li.className = sinif;
    li.appendChild(document.createElement('i'));
    const sp = document.createElement('span');
    sp.textContent = yazi;
    li.appendChild(sp);
    kutu.appendChild(li);
  }

  /* SEPET CEKMECESI — GERCEK SEPET
     Onceden buraya sabit HTML basiliyordu: hangi urun eklenirse eklensin ayni gorsel,
     tek satir, calismayan adet/kaldir dugmeleri ve uydurma puan gorunuyordu.
     Artik cekmece Shopify'in Section Rendering API'siyle sunucudan yeniden cizdiriliyor,
     yani tasarim tek yerde (luvera-header.liquid) duruyor ve icerik hep gercek sepet. */
  const kok = () => window.Shopify?.routes?.root || '/';
  const sepetiTazele = async () => {
    const govde = root.querySelector('[data-luvera-cart-body]');
    let taze = null;
    try {
      const html = await fetch(`${kok()}?section_id=luvera_header`, { headers: { Accept: 'text/html' } }).then((r) => (r.ok ? r.text() : null));
      if (html) taze = new DOMParser().parseFromString(html, 'text/html');
    } catch (_) { taze = null; }
    if (!taze) {
      // yedek yol: sayfayi cek, cekmece govdesini oradan al
      try {
        const html = await fetch(kok(), { headers: { Accept: 'text/html' } }).then((r) => r.text());
        taze = new DOMParser().parseFromString(html, 'text/html');
      } catch (_) { taze = null; }
    }
    if (taze && govde) {
      const yeni = taze.querySelector('[data-luvera-cart-body]');
      if (yeni) govde.innerHTML = yeni.innerHTML;
    }
    // rozetler her durumda gercek sayidan guncellensin
    const cart = await fetch(`${kok()}cart.js`).then((r) => r.json()).catch(() => null);
    if (cart) {
      root.querySelectorAll('[data-luvera-cart-count]').forEach((item) => {
        item.textContent = cart.item_count;
        if (cart.item_count > 0) item.removeAttribute('hidden');
        else if (item.closest('[data-luvera-cart-toggle]')) item.setAttribute('hidden', '');
      });
    }
    holdSayaciniBaslat();
    return cart;
  };

  // adet artir/azalt, kaldir ve onerilenlerden hizli ekleme
  root.addEventListener('click', async (event) => {
    const adet = event.target.closest('[data-luvera-qty]');
    const kaldir = event.target.closest('[data-luvera-remove]');
    const hizliEkle = event.target.closest('[data-luvera-quick-add]');
    if (!adet && !kaldir && !hizliEkle) return;
    event.preventDefault();

    if (hizliEkle) {
      const eskiMetin = hizliEkle.textContent;
      hizliEkle.disabled = true; hizliEkle.textContent = '…';
      try {
        await fetch(`${kok()}cart/add.js`, {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(hizliEkle.dataset.luveraQuickAdd), quantity: 1 }] }),
        });
        await sepetiTazele();
      } catch (_) { hizliEkle.textContent = eskiMetin; hizliEkle.disabled = false; }
      return;
    }

    const satir = event.target.closest('[data-luvera-line-key]');
    if (!satir) return;
    const anahtar = satir.dataset.luveraLineKey;
    let miktar;
    if (kaldir) {
      miktar = 0;
    } else {
      const suanki = Number(satir.querySelector('[data-luvera-qty-value]')?.textContent.replace(/[^\d]/g, '')) || 1;
      miktar = Math.max(0, suanki + Number(adet.dataset.luveraQty));
    }
    satir.style.opacity = '.45';
    try {
      await fetch(`${kok()}cart/change.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: anahtar, quantity: miktar }),
      });
      await sepetiTazele();
    } catch (_) { satir.style.opacity = ''; }
  });

  // rezervasyon seridi: kapalıysa hic basilmaz, acıksa GERCEKTEN geri sayar
  let holdZamanlayici = null;
  const holdSayaciniBaslat = () => {
    if (holdZamanlayici) { clearInterval(holdZamanlayici); holdZamanlayici = null; }
    const serit = root.querySelector('[data-luvera-hold]');
    if (!serit) return;
    const deger = serit.querySelector('[data-luvera-hold-value]');
    if (!deger) return;
    let kalan = (Number(serit.dataset.luveraHold) || 0) * 60;
    const yaz = () => {
      if (kalan <= 0) { clearInterval(holdZamanlayici); holdZamanlayici = null; serit.hidden = true; return; }
      deger.textContent = `${String(Math.floor(kalan / 60)).padStart(2, '0')}:${String(kalan % 60).padStart(2, '0')}`;
      kalan -= 1;
    };
    yaz();
    holdZamanlayici = setInterval(yaz, 1000);
  };
  holdSayaciniBaslat();

  productForm?.addEventListener('submit', async (event) => {
    event.preventDefault();
    const submit = productForm.querySelector('[type="submit"]');
    const id = productForm.querySelector('[name="id"]')?.value;
    const properties = {};
    productForm.querySelectorAll('[name^="properties["]').forEach((input) => {
      const propertyName = input.name.match(/^properties\[(.+)]$/)?.[1];
      if (propertyName && input.value) properties[propertyName] = input.value;
    });
    if (!id) return;
    submit.disabled = true;
    submit.textContent = 'EKLENİYOR…';
    try {
      const lineItem = { id: Number(id), quantity: 1 };
      if (Object.keys(properties).length) lineItem.properties = properties;
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [lineItem] })
      });
      if (!response.ok) throw new Error('Cart request failed');
      await sepetiTazele();
      openSurface('cart');
    } catch (_) {
      submit.textContent = 'TEKRAR DENE';
    } finally {
      submit.disabled = false;
      if (submit.textContent !== 'TEKRAR DENE') submit.innerHTML = 'SEPETE EKLE <span>• ' + (submit.dataset.price || '') + '</span>';
    }
  });

  root.querySelectorAll('.luvera-accordions details').forEach((details) => {
    details.addEventListener('toggle', () => {
      if (!details.open) return;
      details.parentElement.querySelectorAll('details').forEach((item) => { if (item !== details) item.open = false; });
    });
  });

  root.querySelectorAll('[data-luvera-page]').forEach((button) => {
    button.addEventListener('click', () => {
      const grid = root.querySelector('[data-luvera-product-grid]');
      if (!grid) return;
      // ONIZLEME: sayfa numarasina gore ornek kart dizisini kaydirir; boylece kontrol
      // gorunur bir degisiklik yapar (no-op degildir). Gercek sayfalama <a href> kullanir.
      const cards = [...grid.children];
      const sayfa = Number(button.getAttribute('data-luvera-page')) || 1;
      const kaydir = ((sayfa - 1) * 6) % Math.max(1, cards.length);
      for (let n = 0; n < kaydir; n += 1) grid.appendChild(grid.firstElementChild);
      root.querySelectorAll('.luvera-pagination button').forEach((item) => item.classList.remove('is-current'));
      button.classList.add('is-current');
      grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });
})();


/* AYNI GUN KARGO GERI SAYIMI
   Kesim saatine (varsayilan 13:00) kadar kalan sureyi "3 sa 58 dk" olarak yazar;
   kesim gectiyse "Ertesi gün kargoda" der. Saat Turkiye saatine (Europe/Istanbul) gore
   hesaplanir, ziyaretcinin cihaz saat dilimine gore kaymaz. */
(function luveraKargoKesim() {
  const kutular = document.querySelectorAll('[data-luvera-cutoff]');
  if (!kutular.length) return;

  const istanbulSimdi = () => {
    // cihaz saat diliminden bagimsiz: Europe/Istanbul yerel saatini parcalara ayir
    const f = new Intl.DateTimeFormat('tr-TR', {
      timeZone: 'Europe/Istanbul', hour12: false,
      hour: '2-digit', minute: '2-digit', second: '2-digit',
    });
    const p = Object.fromEntries(f.formatToParts(new Date()).filter(x => x.type !== 'literal').map(x => [x.type, Number(x.value)]));
    return { sa: p.hour % 24, dk: p.minute, sn: p.second };
  };

  const yaz = () => {
    const { sa, dk, sn } = istanbulSimdi();
    for (const kutu of kutular) {
      const hedefSa = Number(kutu.getAttribute('data-luvera-cutoff')) || 13;
      const hedefDk = Number(kutu.getAttribute('data-luvera-cutoff-minute')) || 0;
      const oncesi = kutu.getAttribute('data-luvera-cutoff-before') || 'Aynı gün kargo için';
      const sonrasi = kutu.getAttribute('data-luvera-cutoff-after') || 'Ertesi gün kargoda';
      const deger = kutu.querySelector('[data-luvera-cutoff-value]');
      if (!deger) continue;

      const simdiSn = sa * 3600 + dk * 60 + sn;
      const hedefSn = hedefSa * 3600 + hedefDk * 60;
      const metinDugumu = kutu.firstChild;

      if (simdiSn >= hedefSn) {
        if (metinDugumu && metinDugumu.nodeType === 3) metinDugumu.textContent = '';
        deger.textContent = sonrasi;
      } else {
        const kalan = hedefSn - simdiSn;
        const k_sa = Math.floor(kalan / 3600);
        const k_dk = Math.floor((kalan % 3600) / 60);
        if (metinDugumu && metinDugumu.nodeType === 3) metinDugumu.textContent = oncesi + ' ';
        deger.textContent = k_sa > 0 ? k_sa + ' sa ' + k_dk + ' dk' : k_dk + ' dk';
      }
    }
  };

  yaz();
  setInterval(yaz, 1000);
})();
